import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';
import { Order } from 'src/app/models/Order';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
import { DataOrder } from 'src/app/models/DataOrder';
declare var jQuery: any;

@Component({
  selector: 'app-manipulation-order',
  templateUrl: './manipulation-order.component.html',
  styleUrls: ['./manipulation-order.component.scss']
})
export class ManipulationOrderComponent implements OnInit {

  titulos: String[] = ['CIP', 'PEDIDO', 'FECHA SOLICITUD', 'FECHA PREPARACIÓN', ''];
  listOrders: Order[] = [];
  @ViewChild('preparationModal') preparationModal: ModalDirective;
  action: String;
  isData : boolean= false;
  indexOrder: number;
  dateSelect: Date;

  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private orderService: OrderService, private router: Router) { }
  

  ngOnInit() {
    this.spinner.show();
    jQuery.getScript(CONSTANTES.menu);

    this.orderService.getPreparationOrders().subscribe(
      data => {
        if (getToken(data)) {
          if(data!=null && data.orders!=null && data.orders.length>0){
            this.listOrders=data.orders;
            this.isData = true;
          }else{
            this.toastr.info("NO EXISTEN PEDIDOS QUE PREPARAR", "INFO");
            this.isData = false;
            this.router.navigate(['home']);
          }
          
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }  
    )

    this.spinner.hide();
  }

  edit(index: number){
    this.indexOrder = index;
    this.preparationModal.show();
  }

  insertDate(){
    this.listOrders[this.indexOrder].preparationDate = this.dateSelect;
    this.spinner.show();
    let dataOrder : DataOrder = new DataOrder();
    let listOrders2: Order[] = [];
    listOrders2.push(this.listOrders[this.indexOrder]);
    //dataOrder.orders = this.listOrders;
    dataOrder.orders = listOrders2;
    this.orderService.setPreparationOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          dataOrder.orders[this.indexOrder] = data.orders[0];
          this.spinner.hide();
          this.toastr.success("DATO PROCESADO CORRECTAMENTE", "INFO");
          this.listOrders=data.orders;
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
      }  
    )
    this.closePreparationModal();
    this.spinner.hide();
  }

  insertData(){
    this.spinner.show();
    let dataOrder : DataOrder = new DataOrder();
    //dataOrder.orders = this.listOrders;
    dataOrder.orders = this.listOrders.filter(check => {
       return check.preparation;
    });

    this.orderService.setPreparationOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.success("DATOS PROCESADOS CORRECTAMENTE", "INFO");
          this.spinner.hide();
          this.router.navigate(['home']);
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
      }  
    )

    this.spinner.hide();
  }

  closePreparationModal(){
    this.preparationModal.hide();
    this.preparationModal.ngOnDestroy();
  }

  togglecheck(e, index:number){
    if(this.listOrders[index].preparationDate!=null){
      this.listOrders[index].preparation = e.target.checked;
    }else{
      e.target.checked = false;
      this.toastr.info("ES NECESARIO AÑADIR LA FECHA PARA PODER CERRAR LA MANIPULACIÓN", "INFO");
    }
    
  }
}
